import _ from "lodash";
import { isFailure } from "@sportal/api";

import {
  LOAD_CATEGORIES_SUCCESS,
  LOAD_CATEGORIES_FAILURE,
  CategoriesActionTypes,
  SBCategory,
} from "./categories.types";
import { SBThunkAction } from "../redux.types";

export const loadCategories =
  (): SBThunkAction<void, CategoriesActionTypes> =>
  async (dispatch, getState, { api }) => {
    const { categories } = getState();

    if (!_.isEmpty(categories)) return;

    const result = await api.ssm.protection.getCategories();

    if (isFailure(result)) {
      dispatch(loadCategoriesFailure(result.error));

      return;
    }

    dispatch(loadCategoriesSuccess(result.data));
  };

export const loadCategoriesSuccess = (
  categories: SBCategory[]
): CategoriesActionTypes => ({
  type: LOAD_CATEGORIES_SUCCESS,
  payload: categories,
});

export const loadCategoriesFailure = (
  error: object & { code: number | string }
): CategoriesActionTypes => ({
  type: LOAD_CATEGORIES_FAILURE,
  payload: error,
});
